import React, { FunctionComponent, useState } from 'react';
import { map, sort } from 'ramda';
import Button from '../Button';
import { IBindingCallback1 } from '../../../../common/models/callback';
import { IQuestionForReference } from '../../../../common/models/question/IQuestionForReference';
import { getDefaultMessage, getDefaultIntl } from '../Question/utils';
import { QuestionOption } from '../../../../common/enums/QuestionOption';
import RegularButton from '../../../../components/RegularButton';
import { formatQuestionText } from '../../containers/QuestionsContainer/utils';
import styles from './styles.module.scss';

interface IRatingScaleQuestionProps {
  question: IQuestionForReference;
  candidateFirstName: string;
  onAnswer: IBindingCallback1<IQuestionForReference>;
}

const RatingScaleQuestion: FunctionComponent<IRatingScaleQuestionProps> = ({
  question,
  candidateFirstName,
  onAnswer
}) => {
  const [answer, setAnswer] = useState(question.answer);
  const [isClicked, setIsClicked] = useState(false);

  const onClick = (o: QuestionOption) => {
    setAnswer(o);
    setIsClicked(true);
  };

  return (
    <div className="d-flex flex-column align-self-center">
      <div className={styles.scaleQuestionBlock}>
        <p className={styles.questionLead}>
          {formatQuestionText(question.lead, candidateFirstName)}
          &nbsp;...
        </p>
        <div className="survey-page-title">
          {`... ${question.text}`}
        </div>
      </div>
      <div>
        <div className={`d-flex ${styles.buttonGroup}`}>
          {map((o: QuestionOption) => (
            <Button
              key={o}
              onAnimationEnd={() => { onAnswer({ ...question, answer }); setIsClicked(false); }} // Animation purpose
              isClicked={isClicked}
              isSelected={answer === o}
              textIntl={getDefaultIntl(o)}
              defaultText={getDefaultMessage(o)}
              onClick={() => onClick(o)}
            />
          ), sort((a, b) => Number(a) - Number(b), question.options))}
        </div>
        <div className={styles.bttn}>
          <RegularButton
            size="lg"
            variant="tertiary"
            textIntlId="survey.didNotObserve"
            defaultMessage="Did not observe"
            onClick={() => onAnswer({ ...question, answer: '0' })}
          />
        </div>
      </div>
    </div>
  );
};

export default RatingScaleQuestion;
